enum ClaimStatuses {
    NotClaimed = 1,
    Client = 2,
    Partner = 3
}
export default ClaimStatuses;